const STORAGE_KEY = 'canpark.scan.lastSelection';

export interface ScanLastSelection {
	customerId?: string;
	parkingLocationId?: string;
}

export const readScanLastSelection = (): ScanLastSelection => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const writeScanLastSelection = (patch: ScanLastSelection): void => {
	try {
		const merged = { ...readScanLastSelection(), ...patch };
		localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
	} catch {
		// localStorage may be unavailable (private mode, quota); ignore.
	}
};
